// addWhereGroup — VQE-Edit edit-action: append a new parenthesised child group
// (with a starter predicate) into the group at `parentPath`, joined by
// `combinator`. Delegates to SR-Edit `add-where-group` via `commitEdit`.

import type {
  BooleanClauseTarget,
  NodePath,
  WhereCombinator,
} from '../../../../sql-resolver/types/structuralEdit';
import { commitEdit, type CommitEditCtx } from '../commitEdit';
import { formatFilterText, type FilterFormValue } from './filterHelpers';

/**
 * Insert ` <combinator> (<text>)` into the group at `parentPath`, in the
 * WHERE (default) or HAVING (`clause: 'having'`) tree. `predicate` is literal
 * text or a structured `FilterFormValue` stringified via `formatFilterText`
 * (mirrors `addFilterNode`). Returns without applying when the predicate
 * resolves to empty.
 */
export async function addWhereGroup(
  parentPath: NodePath,
  predicate: string | FilterFormValue,
  combinator: WhereCombinator,
  ctx: CommitEditCtx,
  clause?: BooleanClauseTarget,
): Promise<void> {
  const text = (typeof predicate === 'string' ? predicate : formatFilterText(predicate)).trim();
  if (text.length === 0) return;
  await commitEdit({ op: 'add-where-group', parentPath, text, combinator, clause }, ctx);
}
